import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CustomValidators } from 'app/shared/forms/custom-validators';

import { User } from '../user-model';
import { AuthService } from 'app/core/auth/auth.service';
import { DateTimeFormatting } from 'app/core/config/date-formatting.service';

@Component({
  selector: 'signup',
  templateUrl: 'signup.component.html'
})
export class SignupComponent implements OnInit {
  @Output() signup = new EventEmitter();

  signupForm: FormGroup;
  isLoading: boolean = false;
  errorMessage: string;
  validationMessages = {
    'password': {
      'controlsMatch': ''
    },
    'confirmPassword': {
      'controlsMatch': 'Las contraseñas no coinciden'
    }
  };
  dateLocale: any;
  birthdayYearRange: string;



  constructor(
    private _formBuilder: FormBuilder,
    private _authService: AuthService,
    private _dateFormatting: DateTimeFormatting) {

    this.dateLocale = _dateFormatting.currentLocale;

    let currentYear = (new Date).getFullYear();
    this.birthdayYearRange = (currentYear - 50) + ':' + (currentYear - 18);
  }

  ngOnInit(): void {
    this.signupForm = this._formBuilder.group({
      firstName: ['', Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20)
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(40)
      ])],
      middleName: ['', Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(40)
      ])],
      username: ['', Validators.compose([
        Validators.required,
        CustomValidators.email
      ])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(15)
      ])],
      confirmPassword: ['', Validators.compose([
        Validators.required
      ])],
      birthday: [null, Validators.compose([
        Validators.required,
        CustomValidators.legalAge
      ])],
    }, { validator: CustomValidators.controlsMatch('password', 'confirmPassword') });
  }

  onSubmit(): void {
    this.errorMessage = null;

    if (this.signupForm.valid) {
      var user = this.signupForm.value;
      user.username = user.username + '@tcpip.tech';//@pronosticos.gob.mx';
      console.log('Usuario:',user);
    ///
    //this.signup.emit(user);
    ///

      this.isLoading = true;
      this._authService.signup(user)
        .finally(() => this.isLoading = false)
        .subscribe(() => {
          this.signup.emit(user);
        },
        err => {
          this.errorMessage = err;
          this.signup.emit({ message: 'No se ha podido crear tu cuenta. ',err });
        });
    }
  }
}
  /*  this._authService.login({
            username: user.username,
            password: user.password
          })
            .subscribe(() => {
              this.signup.emit();
            },
            err => this.signup.emit({ message: 'Tu cuenta ha sido creada. Intenta iniciar sesión.' }));*/


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/signup/signup.component.ts